<section class="content-container">
    <div class="highlight">
        <div class="highlight__inner">
            <div>
                <h2 translate="Core.SubFooter.Title"></h2>
                <p translate="Core.SubFooter.Body"></p>
                <ul class="links">
                    <li>
                        <a href='tel:{{phoneNumber}}' class="button button-primary"
                           translate="Core.SubFooter.Phone"></a>
                    </li>
                    <li>
                        <a [href]="'Core.Crumbs.Lez.Url' | translate" class="standalone-link" translate="Core.SubFooter.Site"></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
